/* eslint-disable import/order */
import React, { useState } from 'react';
import { isEmpty, pathOr } from 'ramda';
import { useMutation } from '@apollo/react-hooks';
import { useTranslation } from 'react-i18next';

import { CREATE_FEEDBACK } from 'apollo/mutations';
import { KEYS } from 'components/evieOnboarding/utils/constants';
import { HOME_STATUS } from '../utils';
import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { useGetParams } from 'components/evieOnboarding/utils/useGetParams';
import { useEvieAppContext } from '../EvieAppProvider';
import { useEvieHomeContext } from '../EvieHomeProvider';

import SolidButton from 'components/SolidButton';
import WellbeingScale from '../WellbeingScale';
import CommentsSection from '../CommentsSection';
import FeedbackHeader from '../FeedbackHeader';

import './feedback-view.scss';

const FeedbackView = () => {
  const { t } = useTranslation();
  const { refetch } = useEvieAppContext();
  const {
    changeHomeStatus,
    activityType,
    selectedTask: { id },
    setActivityType,
  } = useEvieHomeContext();

  const [userToken] = useLocalStorage(KEYS.USER_TOKEN);
  const { urlToken } = useGetParams();
  const token = userToken || urlToken;
  const [createFeedback] = useMutation(CREATE_FEEDBACK);

  const [selectedPainLevel, setSelectedPainLevel] = useState({});
  const [selectedFeeling, setSelectedFeeling] = useState({});
  const [comment, setComment] = useState('');

  const handleChangeHomeStatus = () => {
    changeHomeStatus(HOME_STATUS.IDLE);
  };

  const handleCreateFeedback = async () => {
    const { value: painLevel } = selectedPainLevel;
    const { value: reliefLevel } = selectedFeeling;

    const response = await createFeedback({
      variables: {
        feedbackInput: {
          feedbackableId: id,
          feedbackableType: activityType,
          difficultyLevel: painLevel,
          satisfactionLevel: reliefLevel,
          comments: comment,
        },
      },
      context: {
        headers: {
          authorization: token ? `Bearer ${token}` : '',
          role: 'individual',
        },
      },
    });

    const errors = pathOr([], ['data', 'createFeedback', 'errors'])(response);
    const emptyErrors = isEmpty(errors);

    if (emptyErrors) {
      setActivityType(null);
      handleChangeHomeStatus();
      refetch();
    }
  };

  const handleChangeComment = ({ target: { value } }) => {
    setComment(value);
  };

  const isDisabled = isEmpty(selectedPainLevel) && isEmpty(selectedFeeling);

  return (
    <section className="feedback-view">
      <FeedbackHeader changeHomeStatus={handleChangeHomeStatus} />
      <section className="feedback-view__form">
        <WellbeingScale
          title={t('evieApp.feedback.wellbeingScale.levelTitle')}
          selectedItem={selectedPainLevel}
          selectItem={setSelectedPainLevel}
        />
        <WellbeingScale
          title={t('evieApp.feedback.wellbeingScale.reliefTitle')}
          selectedItem={selectedFeeling}
          selectItem={setSelectedFeeling}
        />
        <CommentsSection comment={comment} changeComment={handleChangeComment} />
        <SolidButton disabled={isDisabled} className="evie-survey" onClick={handleCreateFeedback}>
          {t('button.send')}
        </SolidButton>
      </section>
    </section>
  );
};

export default FeedbackView;
